module.exports = "/assets/9e30fa59c0f9f117ab5794e0de97ab98.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MQ.png
// module id = 1623
// module chunks = 0